// extracted by mini-css-extract-plugin
export default {"resizable":"ResizableTable_resizable__xuL3E"};